import { ApiBase } from '@/service/api-base'
import { CancelToken } from 'axios'

export class AssessmentRankingsDto {
  /** 单位名称 */
  companyName?: string

  /** 城镇排水污染监管 */
  czpswrjgScore?: string

  /** 化粪池清掏和河道清漂河岸垃圾污染监管 */
  hfchdqpljwrjgScore?: string

  /** 河长制工作落实 */
  hzzgzlsScore?: string

  /** id */
  id?: number

  /** 流域名称 */
  ly?: string

  /** 考核月份 */
  month?: string

  /** 农贸市场污染监管 */
  nmscwrjgScore?: string

  /** 区级河长 */
  qjhz?: string

  /** sort */
  sort?: number

  /** 水质考核排名 */
  szkhRanking?: string

  /** 水质考核得分 */
  szkhhjScore?: string

  /** 水质类别 */
  szlb?: string

  /** 养殖业污染监管 */
  yzywrjgScore?: string

  /** 镇街名次 */
  zjRanking?: string

  /** 镇街考核总分 */
  zjkhTotalScore?: string

  /** 专项整治及监管落实 */
  zxzzjjgls?: string
}

export class CodeReqDto {
  /** code */
  code?: string
}

export class DotMapDto {
  /** 类别 */
  category?: string

  /** 分类名称 */
  categoryStr?: string

  /** 管控级别 */
  gkjb?: string

  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 名称 */
  name?: string

  /** 是否在线，在线true , 不在线false */
  online?: boolean

  /** 排口列表 */
  outPuts?: WsclcInfoItemsDto[]

  /** 水质等级 */
  pollutionLevel?: string

  /** 排污口-整治状态: underway / complete -> 整治中 / 已完成 */
  pwkStats?: string

  /** 排污口-排污口一级分类: gy / czwsclc / ny / other -> 工业 / 城镇污水处理厂 / 农业 / 其它 */
  pwkYjfl?: string

  /** 是否超标   达标db , 超标cb, 无数据wsj */
  standard?: string

  /** 纬度 */
  wd?: string
}

export class DropBoxDto {
  /** 名称 */
  name?: string

  /** 值 */
  value?: string
}

export class EventDetailDto {
  /** 问题所在地址 */
  address?: string

  /** 上报人 */
  createUser?: string

  /** 问题描述 */
  description?: string

  /** 紧急程度 */
  emergencyDegreeStr?: string

  /** 附件列表 */
  fileList?: ZkProblemFileDto[]

  /** id列表 */
  idList?: string[]

  /** 问题所在纬度 */
  latitude?: number

  /** 问题所在经度 */
  longitude?: number

  /** 合并id */
  mergeId?: string

  /** 监测数据 */
  monitorDataDto?: MonitorDataSubjectDto

  /** 当前登录人可以进行的操作列表：['zj:转交','bl:办理','bj:办结','th:退回'] */
  operations?: string[]

  /** 当前任务id */
  problemId?: string

  /** 任务名称 */
  problemName?: string

  /** 问题来源 1:告警推送  2:问题上报  3:任务发布 */
  problemSource?: number

  /** 问题来源 */
  problemSourceStr?: string

  /** 问题状态 */
  problemStatus?: number

  /** 问题状态 */
  problemStatusStr?: string

  /** 问题二级分类 */
  problemSubtype?: number

  /** 问题二级分类转义文字 */
  problemSubtypeStr?: string

  /** 问题类型 */
  problemTypeStr?: string

  /** 上报时间 */
  reportTime?: string

  /** 上报时间Str */
  reportTimeStr?: string

  /** 问题所在流域河段 */
  river?: string

  /** 处理流程 */
  workflowRecordTree?: WorkflowRecordTreeDto[]
}

export class EventListDto {
  /** 问题地址 */
  address?: string

  /** 指派时间 */
  assignTime?: string

  /** 上报人 */
  createUser?: string

  /** 上报人（id） */
  createUserId?: number

  /** 当前处理人(多个逗号隔开) */
  currentHandleUser?: string

  /** 当前处理人集合 */
  currentHandleUserIds?: number[]

  /** 处理期限（单位：天） */
  deadLine?: number

  /** 描述 */
  description?: string

  /** 紧急程度  1:一般  2:重要  3:紧急 */
  emergencyDegree?: number

  /** id */
  id?: string

  /** 合并id */
  mergeId?: string

  /** 职务 */
  position?: string

  /** 问题名称 */
  problemName?: string

  /** 问题来源 */
  problemSource?: number

  /** 问题来源 */
  problemSourceStr?: string

  /** 问题状态 */
  problemStatus?: number

  /** 问题状态 */
  problemStatusStr?: string

  /** 问题类型 */
  problemType?: number

  /** 问题类型 */
  problemTypeStr?: string

  /** 上报时间 */
  reportTime?: string

  /** 上报时间 */
  reportTimeStr?: string

  /** 河流河段 */
  river?: string
}

export class HkSlDto {
  /** 湖库总数 */
  total?: number

  /** 小型数量 */
  xx?: number

  /** 中型数量 */
  zx?: number
}

export class HomeDropSelect {
  children?: HomeDropSelect[]
  name?: string
  value?: string
}

export class HomeMapDropDto {
  childs?: HomeMapDropDto[]
  name?: string
  sortNo?: number
  value?: string
}

export class HzddProblemListDto {
  /** 分类 */
  category?: string

  /** 自动告警编码 */
  deviceMn?: string

  /** 污染因子 */
  factorCode?: string

  /** id */
  id?: string

  /** 纬度 */
  latitude?: string

  /** 经度 */
  longitude?: string

  /** 问题名称 */
  problemName?: string

  /** 处理状态 */
  problemStatus?: number

  /** 处理状态注释 */
  problemStatusStr?: string

  /** 问题类别二级分类 */
  problemSubtype?: number

  /** 问题类别二级分类名称 */
  problemSubtypeStr?: string

  /** 问题类别 */
  problemType?: number

  /** 问题类别名称 */
  problemTypeStr?: string

  /** 上报时间 */
  reportTime?: string
}

export class IdIntegerQuery {
  /** id */
  id?: number
}

export class JsonResult {
  code?: number
  data?: any
  msg?: string
}

export class KeyValue {
  /** key */
  key?: string

  /** value */
  value?: any
}

export class LyQuery {
  /** 流域名称 */
  ly?: string
}

export class MapFilterDto {
  /** 地图坐标点位列表 */
  dotMapList?: DotMapDto[]

  /** 条件(巡河在线/xh_online, 手工监测断面/sgjcdm, 水质自动监测站/szzdjcz,  污水处理厂/wsclc, 重点工业企业/zdgyqy, 规模化畜牧养殖/gmhxmyz, 水产养殖/scyz, 国控站/gkz, 市控站/skz, 一体化站/ythz, 物联站/wlz), 多个逗号隔开 */
  positions?: string

  /** 视频监测点坐标点位列表 */
  spjcdList?: RiverMonitorVideoListDto[]

  /** 水质自动站点位列表 */
  stationList?: StationListDto[]

  /** 污水处理厂点位列表 */
  wsclcList?: WsclcInfoModel[]

  /** 网格员正在巡河的信息列表 */
  xhList?: OnlineWgyItemInfoDto[]
}

export class MonitorDataListDto {
  /** 监测时间 */
  dataTime?: string

  /** 因子 */
  factor?: string

  /** 监测值 */
  value?: number
}

export class MonitorDataSubjectDto {
  /** 监测数据列表 */
  dataList?: MonitorDataListDto[]

  /** 设备mn */
  deviceMn?: string

  /** 因子编码 */
  factorCode?: string

  /** 因子名称 */
  factorName?: string

  /** 标准值 */
  standValues?: number[]

  /** 因子单位 */
  unit?: string
}

export class MonitorVideoItemDto {
  /** id */
  id?: string

  /** 标题名称 */
  title?: string

  /** 监控视频列表 */
  videos?: VideoMonitorPointDto[]
}

export class OnlineMonitorStatisticsDto {
  /** 在线检测数 */
  onlineCount?: number

  /** 总数 */
  totalCount?: number
}

export class OnlineWgyItemInfoDto {
  /** 巡河记录id */
  id?: number

  /** 分项id */
  itemId?: number

  /** 经度 */
  jd?: string

  /** 巡河人电话 */
  lxdh?: string

  /** 重点监管点 */
  prints?: WgyItemPrintDto[]

  /** 起点经度 */
  qdjd?: string

  /** 起点名称 */
  qdmc?: string

  /** 起点纬度 */
  qdwd?: string

  /** 巡河人id */
  userId?: number

  /** 巡河人名称 */
  userName?: string

  /** 纬度 */
  wd?: string

  /** 巡河轨迹 */
  zb?: any[][]

  /** 终点经度 */
  zdjd?: string

  /** 终点名称 */
  zdmc?: string

  /** 终点纬度 */
  zdwd?: string
}

export class ProblemDto {
  /** 处理中数量 */
  clzQuantity?: number

  /** 问题列表 */
  problemList?: ProblemListDto[]

  /** 问题总数量 */
  wtQuantity?: number

  /** 已处理数量 */
  yclQuantity?: number
}

export class ProblemListDto {
  /** 处理状态 */
  handleStatus?: number

  /** 处理状态注释 */
  handleStatusStr?: string

  /** id */
  id?: string

  /** 纬度 */
  latitude?: string

  /** 经度 */
  longitude?: string

  /** 问题名称 */
  name?: string

  /** 问题类别 */
  problemType?: number

  /** 问题类别名称 */
  problemTypeStr?: string

  /** 问题描述 */
  remark?: string

  /** 上报时间 */
  upTime?: string

  /** 上报人 */
  upUser?: number
}

/**
 * 排污口信息（该数据是数据分析组提供）
 */
export class PwkBasicRespDto {
  /** 二级分类 */
  ejfl?: string

  /** 二级功能区 */
  ejgnq?: string

  /** 二级功能区目标 */
  ejgnqmb?: string

  /** 废水排放量m³/d */
  fspflD?: string

  /** id */
  id?: number

  /** 地理位置经度 */
  jd?: string

  /** 关联在线监测设备分组 */
  linkMonitorDeviceCode?: string[]

  /** 关联视频监测设备编码 */
  linkVideoDeviceCode?: string[]

  /** 排污口编码 */
  pwkbm?: string

  /** 排污口类型 */
  pwklx?: string

  /** 排污口名称 */
  pwkmc?: string

  /** 排污口所在水系 */
  pwkszsx?: string

  /** 排污口详细地址 */
  pwkxxdz?: string

  /** 备注 */
  remark?: string

  /** 是否纳入系统：是、否 */
  sfnrxt?: string

  /** 是否纳入整治：是、否 */
  sfnrzz?: string

  /** 是否完成整治 */
  sfwczz?: string

  /** 是否有水功能区：是、否 */
  sfysgnq?: string

  /** 受纳水体 */
  snst?: string

  /** 审批登记情况 */
  spdjqk?: string

  /** 审批登记情况详情 */
  spdjqkxq?: string

  /** 受影响的国控断面类型 */
  syxdgkdmlx?: string

  /** 影响国控断面名称 */
  syxdgkdmmc?: string

  /** 所在流域 */
  szly?: string

  /** 乡镇、街道或行政村 */
  szzj?: string

  /** 地理位置纬度 */
  wd?: string

  /** 现场照片 */
  xczp?: string[]

  /** 一级分类 */
  yjfl?: string

  /** 执行排放标准 */
  zxpfbz?: string
}

export class PwkCkzbRespDto {
  /** 工业企业点位列表 */
  gyqyList?: DotMapDto[]

  /** 工业园区点位列表 */
  gyyqList?: DotMapDto[]

  /** 排水管网点位列表 */
  psgwList?: DotMapDto[]

  /** 自己的点 */
  self?: DotMapDto

  /** 水质自动站点位列表 */
  szzdzList?: DotMapDto[]

  /** 污水处理厂点位列表 */
  wsclcList?: WsclcInfoModel[]
}

export class PwkFltjRespDto {
  /** 一级分类统计：工业 */
  gyItem?: PwkqkLevelOneRespDto

  /** 一级分类统计：农业 */
  nyItem?: PwkqkLevelOneRespDto

  /** 一级分类统计：其他 */
  otherItem?: PwkqkLevelOneRespDto

  /** 一级分类统计：生活 */
  shItem?: PwkqkLevelOneRespDto
}

export class PwkSgjcMonitorFactorDto {
  /** 因子编码 */
  factorCode?: string

  /** 因子 */
  factorName?: string

  /** 监测值 */
  monitorValue?: string

  /** 标准值 */
  standValue?: string
}

export class PwkSgjcRespDto {
  /** 采样方式 */
  cyfs?: string

  /** 采样位置 */
  cywz?: string

  /** 采样现场情况描述 */
  cyxcqkms?: string

  /** 过水断面面积(m2) */
  gsdmmj?: string

  /** 监测报告 */
  jcbg?: string

  /** 监测采样编码 */
  jccybm?: string

  /** 监测单位 */
  jcdw?: string

  /** 监测方法 */
  jcfs?: string

  /** 排污时长(h/d) */
  pwsc?: string

  /** 备注 */
  remark?: string

  /** 是否具备建自动站条件：是、否 */
  sfjbjzdjcztj?: string

  /** 是否开展自动监测：是、否 */
  sfkzzdjc?: string

  /** 是否已建自动监测站：是、否 */
  sfyjczdjcz?: string

  /** 监测表格 */
  sgjcMonitors?: PwkSgjcMonitorFactorDto[]

  /** 特征污染物 */
  tzwrw?: string

  /** 位置描述 */
  wzms?: string

  /** 现场采样时间 */
  xccysj?: string

  /** 现场监测项目 */
  xcjcxm?: string
}

export class PwkSgjcsjDetailReqDto {
  /** 页码,默认1 */
  page!: number

  /** 每页显示条数,默认10 */
  pageSize!: number

  /** 排污口编码 */
  pwkbm?: string

  /** 排污口名称 */
  pwkmc?: string

  /** 时间标记：天/周/月/年   d/w/m/y */
  timeFlag?: string
}

export class PwkSgjcsjDetailRespDto {
  /** 历史数据列表 */
  pageList?: PageListSjfxPwkSgjcsjDto

  /** 排污口编码 */
  pwkbm?: string

  /** 排污口名称 */
  pwkmc?: string
}

export class PwkSgjcsjReqDto {
  /** 页码,默认1 */
  page!: number

  /** 每页显示条数,默认10 */
  pageSize!: number

  /** 时间标记：天/周/月/年   d/w/m/y */
  timeFlag?: string
}

export class PwkSgjcsjRespDto {
  /** 是否超标 */
  cbStr?: string

  /** 监测时间 */
  dataTime?: string

  /** 氟化物监测值 */
  fhw?: number

  /** 数据id */
  id?: number

  /** 水质结果 */
  pjjg?: string

  /** 排污口编码 */
  pwkbm?: string

  /** 排污口名称 */
  pwkmc?: string

  /** 水质标准 */
  szbz?: string
}

export class PwkZdjcReqDto {
  /** code */
  code?: string

  /** 监测日期 */
  dateTime?: string
}

export class PwkZdjcRespDto {
  /** 表头 */
  headers?: TitleModel[]

  /** 最新数据时间 */
  latestDataTime?: string

  /** 动态因子列表 */
  rows?: Record<string, any>[]

  /** 执行排放标准 */
  zxpfbz?: string
}

export class PwkZxjcFactorRespDto {
  /** 动态因子值 */
  dataJson?: Record<string, any>

  /** 数据时间 */
  dataTime?: any

  /** 在线监测设备编码 */
  deviceCode?: string

  /** 名称 */
  name?: string
}

export class PwkZxjcReqDto {
  /** 流域名称 */
  ly?: string

  /** 一级分类 */
  yjfl?: string
}

export class PwkZxjcRespDto {
  /** 排污口监测因子 */
  datas?: PwkZxjcFactorRespDto[]

  /** 因子动态表头 */
  headers?: TitleModel[]
}

/**
 * 排污口分类
 */
export class PwkflDto {
  /** 所属排污口二级分类 */
  ejfls?: string[]

  /** 排污口一级分类 */
  yjfl?: string
}

/**
 * 排污口二级分类统计对象
 */
export class PwkgkLevelTwoRespDto {
  /** 分类名称 */
  flname?: string

  /** 纳入整治数 */
  nrzzQuantity?: number

  /** 排口数量 */
  quantity?: number

  /** 已完成整治数 */
  ywczzQuantity?: number
}

/**
 * 排污口概况响应对象
 */
export class PwkgkRespDto {
  /** 默认的点位(全部) */
  defaultMapPrints?: DotMapDto[]

  /** 默认分类统计(全部) */
  defaultfltj?: PwkFltjRespDto

  /** 纳入整治对应的点位 */
  nrzzMapPrints?: DotMapDto[]

  /** 纳入整治数 */
  nrzzQuantity?: number

  /** 纳入整治一级分类统计 */
  nrzzfltj?: PwkFltjRespDto

  /** 全域总数 */
  totalQuantity?: number

  /** 已完成整治对应的点位 */
  ywczzMapPrints?: DotMapDto[]

  /** 已完成整治数 */
  ywczzQuantity?: number

  /** 已完成整治一级分类统计 */
  ywczzfltj?: PwkFltjRespDto
}

/**
 * 排污口一级分类统计对象
 */
export class PwkqkLevelOneRespDto {
  /** 二级分类列表 */
  items?: PwkgkLevelTwoRespDto[]

  /** 对应的点位 */
  mapPrints?: DotMapDto[]

  /** 比例 */
  rate?: number

  /** 分类总数 */
  totalQuantity?: number
}

export class PwkwtqdPageReqDto {
  /** 开始时间 */
  beginTime?: string

  /** 排污口编码 */
  code?: string

  /** 结束时间 */
  endTime?: string

  /** 页码,默认1 */
  page!: number

  /** 每页显示条数,默认10 */
  pageSize!: number
}

export class PwkxcjlPageReqDto {
  /** 开始时间 */
  beginTime?: string

  /** 排污口编码 */
  code?: string

  /** 结束时间 */
  endTime?: string

  /** 页码,默认1 */
  page!: number

  /** 每页显示条数,默认10 */
  pageSize!: number
}

export class RankingTimesDto {
  /** 年月 */
  month?: string

  /** 时间 年月日 */
  time?: string

  /** 年份 */
  year?: string
}

export class RiverCountDto {
  /** 河流条数 */
  count?: number

  /** 流域 */
  ly?: string

  /** 所占百分比 */
  percentage?: string

  /** 河流总条数 */
  totalCount?: number
}

export class RiverLeaderQuantityDto {
  /** 河长数量 */
  hzQuantity?: number

  /** 在线数量 */
  onlineQuantity?: number

  /** 网格员数量 */
  wgyQuantity?: number
}

export class RiverMonitorVideoListDto {
  /** 接入方式 */
  accessMode?: number

  /** 视频点位id */
  id?: string

  /** 纬度 */
  latitude?: string

  /** 经度 */
  longitude?: string

  /** 是否在线：1是0否 */
  onlined?: number

  /** 视频站点名称 */
  stationName?: string

  /** 视频类型 1.河道视频监控、2.污染源视频监控、3.水库视频监控、4.饮用水源地视频监控、5.管网视频监控 */
  videoType?: number
}

export class SjfxPwkSgjcsjDto {
  /** 监测时间 */
  dataTime?: string

  /** 氟化物监测值 */
  fhw?: number

  /** 数据id */
  id?: number

  /** 排污口编码 */
  pwkbm?: string

  /** 排污口名称 */
  pwkmc?: string
}

/**
 * 排污口信息（该数据是数据分析组提供）
 */
export class SjfxPwkxxInfoDto {
  /** 二级分类 */
  ejfl?: string

  /** 二级功能区 */
  ejgnq?: string

  /** 二级功能区目标 */
  ejgnqmb?: string

  /** 废水排放量m³/d */
  fspflD?: string

  /** id */
  id?: number

  /** 地理位置经度 */
  jd?: string

  /** 关联在线监测设备分组 */
  linkMonitorDeviceCode?: string[]

  /** 关联视频监测设备编码 */
  linkVideoDeviceCode?: string[]

  /** 排污口编码 */
  pwkbm?: string

  /** 排污口类型 */
  pwklx?: string

  /** 排污口名称 */
  pwkmc?: string

  /** 排污口所在水系 */
  pwkszsx?: string

  /** 排污口详细地址 */
  pwkxxdz?: string

  /** 备注 */
  remark?: string

  /** 是否纳入系统：是、否 */
  sfnrxt?: string

  /** 是否纳入整治：是、否 */
  sfnrzz?: string

  /** 是否有水功能区：是、否 */
  sfysgnq?: string

  /** 受纳水体 */
  snst?: string

  /** 审批登记情况 */
  spdjqk?: string

  /** 审批登记情况详情 */
  spdjqkxq?: string

  /** 受影响的国控断面类型 */
  syxdgkdmlx?: string

  /** 影响国控断面名称 */
  syxdgkdmmc?: string

  /** 所在流域 */
  szly?: string

  /** 乡镇、街道或行政村 */
  szzj?: string

  /** 地理位置纬度 */
  wd?: string

  /** 现场照片 */
  xczp?: string[]

  /** 一级分类 */
  yjfl?: string

  /** 执行排放标准 */
  zxpfbz?: string
}

/**
 * 政策法规
 */
export class SjfxZcfgInfoDto {
  /** 内容 */
  content?: string

  /** 法规编号 */
  fgbh?: string

  /** 附件链接 */
  fileUrl?: string
  fileUrlList?: string[]

  /** id */
  id?: number

  /** 类型 */
  lx?: string

  /** 发布时间 */
  publishTime?: string

  /** 外部跳转地址 */
  requestUrl?: string

  /** 序号 */
  sorted?: number

  /** 名称/标题 */
  title?: string
}

export class StationListDto {
  /** 站点编码 */
  indexCode?: string

  /** 站点名称 */
  indexName?: string

  /** 纬度 */
  latitude?: string

  /** 经度 */
  longitude?: string

  /** 站点种类 */
  nature?: string

  /** 站点状态(online.在线, offline.离线, overStandard.超标) */
  status?: string

  /** 站点类型（1.国控、2.市控、3.一体化站、4.物联站、5.镇控） */
  type?: string
}

export class StationListForMapModel {
  /** 坐标系 */
  coordinateSystem?: string

  /** 出入境类型：cj/rj/other */
  crjlx?: string

  /** 当前水质 */
  currentWaterQuality?: string

  /** 监测时间 */
  dataTime?: string

  /** 纬度 */
  latitude?: string

  /** 经度 */
  longitude?: string

  /** mn */
  mn?: string

  /** 河流 */
  river?: string

  /** 断面名称 */
  sectionName?: string

  /** 设备状态 */
  status?: string

  /** 水质目标 */
  target?: string

  /** 站点类别（1.国控、2.市控、3.一体化站、4.物联站） */
  type?: string

  /** 镇街 */
  zj?: string
}

export class SyaxGroupDto {
  /** 分组名称 */
  groupName?: string

  /** 分项 */
  items?: SyaxItemDto[]

  /** 分组序号 */
  sort?: number
}

export class SyaxItemDto {
  /** 设施序号 */
  sort?: number

  /** 设施数量 */
  ssQuantity?: number

  /** 设施类型名称 */
  ssTypeName?: string

  /** 设施单位 */
  ssUnit?: string
}

export class SzzdzYcszFactorRespDto {
  /** 因子编码 */
  factorCode?: string

  /** 因子名称 */
  factorName?: string

  /** 因子单位 */
  unit?: string
}

export class SzzdzYcszRespDto {
  /** y轴数据 */
  datas?: any[][]

  /** 时间轴 */
  dateAxis?: string[]

  /** 因子标准线 */
  stands?: string[][]
  xaxis?: string[]
}

export class TitleModel {
  /** 因子编码 */
  identifier?: string

  /** 对应的中文名称 */
  name?: string

  /** 单位 */
  unit?: string
}

export class Type {
  typeName?: string
}

export class VideoMonitorPointDto {
  /** 接入方式(这是字符串参数，展示用) */
  accessType?: number

  /** 接入方式 */
  accessTypeStr?: string

  /** 详细地址 */
  address?: string

  /** 视频监测设备通道号 */
  deviceChannelNumber?: string

  /** 管理级别:重点、非重点 */
  gljb?: string

  /** 视频监测点id */
  id?: string

  /** 视频监测设备是否可用：1是，0否 */
  isAvailable?: number

  /** 视频监测设备是否可以进行云台控制：1是，0否 */
  isControl?: number

  /** 经度 */
  jd?: string

  /** 关联站点id */
  linkStationId?: string

  /** 关联站点名称 */
  linkStationName?: string

  /** 关联站点类型 */
  linkStationType?: number

  /** 关联站点类型(这是字符串参数，展示用) */
  linkStationTypeStr?: string

  /** 流域名称 */
  ly?: string

  /** 备注 */
  remark?: string

  /** 河流名称 */
  river?: string

  /** 显示排序 */
  sorted?: number

  /** 所在镇街名称 */
  szzj?: string

  /** 视频监测设备编码/设备序列号 */
  videoDeviceCode?: string

  /** 视频监测设备名称 */
  videoDeviceName?: string

  /** 视频监测设备类型：0.其他 1.球机 2.枪机 */
  videoDeviceType?: number

  /** 视频监测设备类型(这是字符串参数，展示用) */
  videoDeviceTypeStr?: string

  /** 固定的视频码流地址 */
  videoStream?: string

  /** 视频类型 */
  videoType?: number

  /** 视频类型分组(这是字符串参数，展示用) */
  videoTypeStr?: string

  /** 纬度 */
  wd?: string

  /** 视频监测设备维护企业名称 */
  whqy?: string
}

export class VideoStreamDto {
  /** 视频监测点id */
  videoPrintId?: string

  /** 视频播放地址 */
  videoStream?: string
}

export class WaterAssessmentDto {
  /** 当前数据月 */
  currentMonth?: string

  /** 国考 */
  gkDto?: WaterAssessmentGKDto

  /** 最新数据月 */
  month?: string

  /** 区考 */
  qkDto?: WaterAssessmentGKDto

  /** 市考 */
  skDto?: WaterAssessmentGKDto

  /** 物联站 */
  wlzDto?: WaterAssessmentGKDto

  /** 一体化 */
  ythDto?: WaterAssessmentGKDto
}

export class WaterAssessmentGKDto {
  /** 超标 */
  cb?: number

  /** 超标站点集合 */
  cbSitenames?: Record<string, any>[]

  /** 达标 */
  db?: number

  /** 达标率 */
  dbRate?: number

  /** 达标站点集合 */
  dbSitenames?: Record<string, any>[]

  /** 总数 */
  total?: number

  /** 所有站点集合 */
  totalSitenames?: Record<string, any>[]

  /** 无数据/离线 */
  wjc?: number
}

export class WaterPollutionDto {
  /** 超标数 */
  cb?: number

  /** 接入数 */
  join?: number

  /** 名称 */
  name?: string

  /** 总数 */
  total?: number
}

export class WgyItemPrintDto {
  id?: number

  /** 经度 */
  jd?: string

  /** 纬度 */
  wd?: string

  /** 站点名称 */
  zdjgd?: string
}

export class WorkflowRecordTreeDto {
  /** 指派时间 */
  assignTime?: string

  /** 指派时间Str */
  assignTimeStr?: string

  /** 指派人员 */
  assignUser?: string

  /** 子流程 */
  childList?: WorkflowRecordTreeDto[]

  /** 处理期限（单位：天） */
  deadline?: number

  /** 处理意见描述 */
  description?: string

  /** 评论列表 */
  evaluations?: WorkflowRecordTreeDto[]

  /** 附件列表 */
  fileList?: ZkProblemFileDto[]

  /** 流程描述 */
  flowDesc?: string

  /** 处理状态 1:待处理 2:处理中 3:已办结 */
  handleStatus?: number

  /** 处理状态 */
  handleStatusStr?: string

  /** 处理时间 */
  handleTime?: string

  /** 处理时间Str */
  handleTimeStr?: string

  /** 执行类型（1:执行/2:督办） */
  handleType?: number

  /** 执行类型 */
  handleTypeStr?: string

  /** 处理人员 */
  handleUser?: string

  /** id */
  id?: string

  /** 是否可以流程进行评价 */
  ifEvaluation?: boolean

  /** 是否合并单据（1是，0否） */
  merged?: number
  pid?: string

  /** 职务 */
  position?: string

  /** 职务全名 */
  positionFullName?: string

  /** 问题id */
  problemId?: string

  /** 处理进度 */
  schedule?: number

  /** 整改措施 */
  zgcs?: string

  /** 整改措施Str */
  zgcsStr?: string
}

export class WrsyBoomListStatisticsVO {
  /** 报警次数 */
  boomCount?: number

  /** 报警时间 */
  boomTime?: string

  /** 报警类别 1:超标报警 2:突变报警 */
  boomType?: string

  /** 报警问题 */
  data?: HzddProblemListDto[]

  /** 点位信息 */
  dotMap?: DotMapDto

  /** mn */
  mn?: string

  /** 问题描述 */
  problemDesc?: string
}

export class WrsyProblemQuery {
  /** 开始时间 */
  beginTime?: string

  /** 超标因子 */
  cbFactor?: string

  /** 重要程度 */
  emergencyDegree?: number

  /** 结束时间 */
  endTime?: string

  /** 经度 */
  jd?: number

  /** 河流点位 */
  points?: any[]

  /** 问题来源 */
  problemSource?: number

  /** 河道范围米数 */
  scope?: number

  /** 上游范围 */
  syfw?: number

  /** 纬度 */
  wd?: number

  /** 下游范围 */
  xyfw?: number
}

export class WrysspfImmobilizationFactorRespDto {
  /** cod（化学需氧量） */
  cod?: any

  /** 监测时间 */
  dataTime?: any

  /** 纬度 */
  latitude?: string

  /** 经度 */
  longitude?: string

  /** nh（氨氮） */
  nh?: any

  /** 排口编码 */
  outputCode?: string

  /** 排口名称 */
  outputName?: string

  /** 污染源psCode */
  psCode?: string

  /** 污染源名称 */
  psName?: string

  /** tn（总氮） */
  tn?: any

  /** tp（总磷） */
  tp?: any
}

export class WrywtListItemDto {
  /** 告警类别 */
  boomTypeStr?: string

  /** 告警描述 */
  content?: string

  /** 告警时间 */
  dataTimeStr?: string

  /** 告警状态 */
  status?: number

  /** 告警状态Str */
  statusStr?: string
}

export class WrywtListReqDto {
  /** 开始时间（yyyy-MM-dd） */
  beginTime?: string

  /** 开始时间（yyyy-MM-dd） */
  endTime?: string

  /** 流域名称 */
  ly?: string

  /** 获取数据的条数 */
  rowSize?: number
}

export class WrywtListRespDto {
  /** 开始时间 */
  beginTime?: string

  /** 污染源问题列表 */
  datas?: WrywtListItemDto[]

  /** 结束时间 */
  endTime?: string

  /** 流域名称 */
  ly?: string
}

export class WrywtStatisticalCurveReqDto {
  /** 开始时间（yyyy-MM-dd） */
  beginTime?: string

  /** 开始时间（yyyy-MM-dd） */
  endTime?: string

  /** 流域名称 */
  ly?: string
}

export class WrywtStatisticalCurveRespDto {
  /** 开始时间 */
  beginTime?: string

  /** 日期数组 */
  days?: string[]

  /** 结束时间 */
  endTime?: string

  /** 流域名称 */
  ly?: string

  /** 污染源问题数量数组 */
  quantitys?: any[]
}

export class WsclcInfoItemsDto {
  /** 排口在线状态 */
  online?: number

  /** 排口编码 */
  outPutCode?: string

  /** 排口名称 */
  outPutName?: string

  /** 排口状态 */
  stru?: string
}

export class WsclcInfoModel {
  /** 地理位置 */
  address?: string

  /** 设备启用状态： 0正常，1异常 */
  boomStatus?: number

  /** 处理能力等级1表示最大，4表示最小 */
  clLevel?: number

  /** 纬度 */
  latitude?: string

  /** 经度 */
  longitude?: string

  /** 设备状态：0离线 / 1在线  */
  onlineStatus?: number

  /** 排口列表 */
  outPuts?: WsclcInfoItemsDto[]

  /** 排放标准 */
  pfbz?: string

  /** 编码 */
  psCode?: string

  /** 污水处理厂名称 */
  psName?: string

  /** 接入状态：1接入， 0未接入 */
  sfazzxjc?: string

  /** 所属区域 */
  ssqy?: string

  /** 水体名称 */
  stmc?: string

  /** 超标状态：cb(超标) / db(达标) / wsj(无数据-离线) */
  stru?: string
}

export class XcjlPageDto {
  /** 河段起点 */
  hdqd?: string

  /** 河段终点 */
  hdzd?: string

  /** 河流名称 */
  hlmc?: string

  /** 巡河记录id */
  id?: number

  /** 上报问题数量 */
  sbwts?: number

  /** 责任人id */
  userId?: number

  /** 网格编号 */
  wgbh?: string

  /** 巡河范围 */
  xcfw?: string

  /** 巡河结束时间 */
  xhjssj?: string

  /** 巡河开始时间 */
  xhkssj?: string

  /** 巡河类型：1常规巡河，2临时巡河 */
  xhlx?: number

  /** 责任人 */
  xhr?: string

  /** 巡河状态 */
  xhzt?: string
}

export class XhIndexDto {
  /** 部门河长 */
  bmHz?: string

  /** 河长级别 */
  hzjb?: string

  /** 巡河记录id */
  id?: number

  /** 经度 */
  jd?: string

  /** 联系电话 */
  lxdh?: string

  /** 联系河段 */
  lxhd?: string

  /** 区级河长 */
  qjHz?: string

  /** 巡河人id */
  userId?: number

  /** 巡河人名称 */
  userName?: string

  /** 纬度 */
  wd?: string

  /** 镇街 */
  zj?: string

  /** 镇街河长 */
  zjHz?: string

  /** 职务 */
  zw?: string
}

export class ZcfgListReqDto {
  /** 法规编号/标题模糊查询 */
  keyword?: string

  /** 法规类型 */
  lx?: string

  /** 页码,默认1 */
  page!: number

  /** 每页显示条数,默认10 */
  pageSize!: number
}

export class ZcfgListRespDto {
  /** 政策法规编号 */
  fgbh?: string

  /** id */
  id?: number

  /** 政策法规类型 */
  lx?: string

  /** 发布时间 */
  publishTime?: string

  /** 外部跳转地址 */
  requestUrl?: string

  /** 排序 */
  sorted?: number

  /** 标题 */
  title?: string
}

export class ZkProblemFileDto {
  /** 文件名称 */
  fileName?: string

  /** 文件路径 */
  filePath?: string

  /** 文件类型(image,video,audio,doc,other) */
  fileType?: string

  /** 模块id（问题id/流程id） */
  modelId?: string
}

export class ZrztgkReqDto {
  /** 二级分类 */
  ejfl?: string

  /** 流域名称 */
  ly?: string

  /** 一级分类 */
  yjfl?: string
}

export class ZrztgkRespDto {
  /** 对应的点位 */
  mapPrints?: DotMapDto[]

  /** 纳入整治数 */
  nrzzQuantity?: number

  /** 总数 */
  totalQuantity?: number

  /** 已完成整治数 */
  ywczzQuantity?: number

  /** 责任主体 */
  zrzt?: string
}

export class JsonResultEventDetailDto {
  code?: number
  data?: EventDetailDto
  msg?: string
}

export class JsonResultHkSlDto {
  code?: number
  data?: HkSlDto
  msg?: string
}

export class JsonResultListAssessmentRankingsDto {
  code?: number
  data?: AssessmentRankingsDto[]
  msg?: string
}

export class JsonResultListDropBoxDto {
  code?: number
  data?: DropBoxDto[]
  msg?: string
}

export class JsonResultListHomeDropSelect {
  code?: number
  data?: HomeDropSelect[]
  msg?: string
}

export class JsonResultListHomeMapDropDto {
  code?: number
  data?: HomeMapDropDto[]
  msg?: string
}

export class JsonResultListKeyValue {
  code?: number
  data?: KeyValue[]
  msg?: string
}

export class JsonResultListMonitorVideoItemDto {
  code?: number
  data?: MonitorVideoItemDto[]
  msg?: string
}

export class JsonResultListPwkSgjcRespDto {
  code?: number
  data?: PwkSgjcRespDto[]
  msg?: string
}

export class JsonResultListPwkflDto {
  code?: number
  data?: PwkflDto[]
  msg?: string
}

export class JsonResultListRiverCountDto {
  code?: number
  data?: RiverCountDto[]
  msg?: string
}

export class JsonResultListStationListForMapModel {
  code?: number
  data?: StationListForMapModel[]
  msg?: string
}

export class JsonResultListSyaxGroupDto {
  code?: number
  data?: SyaxGroupDto[]
  msg?: string
}

export class JsonResultListSzzdzYcszFactorRespDto {
  code?: number
  data?: SzzdzYcszFactorRespDto[]
  msg?: string
}

export class JsonResultListVideoStreamDto {
  code?: number
  data?: VideoStreamDto[]
  msg?: string
}

export class JsonResultListWaterPollutionDto {
  code?: number
  data?: WaterPollutionDto[]
  msg?: string
}

export class JsonResultListWrsyBoomListStatisticsVO {
  code?: number
  data?: WrsyBoomListStatisticsVO[]
  msg?: string
}

export class JsonResultListWrysspfImmobilizationFactorRespDto {
  code?: number
  data?: WrysspfImmobilizationFactorRespDto[]
  msg?: string
}

export class JsonResultListXhIndexDto {
  code?: number
  data?: XhIndexDto[]
  msg?: string
}

export class JsonResultListZrztgkRespDto {
  code?: number
  data?: ZrztgkRespDto[]
  msg?: string
}

export class JsonResultMapFilterDto {
  code?: number
  data?: MapFilterDto
  msg?: string
}

export class JsonResultMapStringObject {
  code?: number
  data?: any
  msg?: string
}

export class JsonResultOnlineMonitorStatisticsDto {
  code?: number
  data?: OnlineMonitorStatisticsDto
  msg?: string
}

export class JsonResultPageListEventListDto {
  code?: number
  data?: PageListEventListDto
  msg?: string
}

export class JsonResultPageListPwkSgjcsjRespDto {
  code?: number
  data?: PageListPwkSgjcsjRespDto
  msg?: string
}

export class JsonResultPageListXcjlPageDto {
  code?: number
  data?: PageListXcjlPageDto
  msg?: string
}

export class JsonResultPageListZcfgListRespDto {
  code?: number
  data?: PageListZcfgListRespDto
  msg?: string
}

export class JsonResultProblemDto {
  code?: number
  data?: ProblemDto
  msg?: string
}

export class JsonResultPwkBasicRespDto {
  code?: number
  data?: PwkBasicRespDto
  msg?: string
}

export class JsonResultPwkCkzbRespDto {
  code?: number
  data?: PwkCkzbRespDto
  msg?: string
}

export class JsonResultPwkSgjcsjDetailRespDto {
  code?: number
  data?: PwkSgjcsjDetailRespDto
  msg?: string
}

export class JsonResultPwkZdjcRespDto {
  code?: number
  data?: PwkZdjcRespDto
  msg?: string
}

export class JsonResultPwkZxjcRespDto {
  code?: number
  data?: PwkZxjcRespDto
  msg?: string
}

export class JsonResultPwkgkRespDto {
  code?: number
  data?: PwkgkRespDto
  msg?: string
}

export class JsonResultRankingTimesDto {
  code?: number
  data?: RankingTimesDto
  msg?: string
}

export class JsonResultRiverLeaderQuantityDto {
  code?: number
  data?: RiverLeaderQuantityDto
  msg?: string
}

export class JsonResultSjfxPwkxxInfoDto {
  code?: number
  data?: SjfxPwkxxInfoDto
  msg?: string
}

export class JsonResultSjfxZcfgInfoDto {
  code?: number
  data?: SjfxZcfgInfoDto
  msg?: string
}

export class JsonResultSzzdzYcszRespDto {
  code?: number
  data?: SzzdzYcszRespDto
  msg?: string
}

export class JsonResultWaterAssessmentDto {
  code?: number
  data?: WaterAssessmentDto
  msg?: string
}

export class JsonResultWrywtListRespDto {
  code?: number
  data?: WrywtListRespDto
  msg?: string
}

export class JsonResultWrywtStatisticalCurveRespDto {
  code?: number
  data?: WrywtStatisticalCurveRespDto
  msg?: string
}

export class PageListEventListDto {
  /** 当前页相关数据 */
  items?: EventListDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListPwkSgjcsjRespDto {
  /** 当前页相关数据 */
  items?: PwkSgjcsjRespDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListSjfxPwkSgjcsjDto {
  /** 当前页相关数据 */
  items?: SjfxPwkSgjcsjDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListXcjlPageDto {
  /** 当前页相关数据 */
  items?: XcjlPageDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListZcfgListRespDto {
  /** 当前页相关数据 */
  items?: ZcfgListRespDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

/**
 * @title 环投网络流域公众服务平台接口文档
 * @version 1.0
 * @baseUrl //119.84.149.201/api/basin
 * 本文档描述了接口定义规范
 */
export class Api<SecurityDataType = any> extends ApiBase {
  pwkSubject = {
    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name CkzbUsingPost
     * @summary 查看周边
     * @request POST:/pwk-subject/ckzb
     */
    ckzbUsingPost: (reqDto: CodeReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPwkCkzbRespDto>(`/pwk-subject/ckzb`, 'POST', reqDto, cancelToken),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name DefaultVideoUsingPost
     * @summary 默认视频展示
     * @request POST:/pwk-subject/defaultVideo
     */
    defaultVideoUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListVideoStreamDto>(
        `/pwk-subject/defaultVideo`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name MatchPwkAndPrintUsingPost
     * @summary 匹配排污口和监测点
     * @request POST:/pwk-subject/matchPwkAndPrint
     */
    matchPwkAndPrintUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/pwk-subject/matchPwkAndPrint`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwkBasicUsingPost
     * @summary 排污口基本信息
     * @request POST:/pwk-subject/pwkBasic
     */
    pwkBasicUsingPost: (reqDto: CodeReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPwkBasicRespDto>(`/pwk-subject/pwkBasic`, 'POST', reqDto, cancelToken),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwkSgjcsjUsingPost
     * @summary 排污口手工监测数据-雨水排口
     * @request POST:/pwk-subject/pwkSgjcsj
     */
    pwkSgjcsjUsingPost: (reqDto: PwkSgjcsjReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListPwkSgjcsjRespDto>(
        `/pwk-subject/pwkSgjcsj`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwkSgjcsjDetailUsingPost
     * @summary 排污口手工监测数据-雨水排口-详情
     * @request POST:/pwk-subject/pwkSgjcsjDetail
     */
    pwkSgjcsjDetailUsingPost: (
      reqDto: PwkSgjcsjDetailReqDto,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultPwkSgjcsjDetailRespDto>(
        `/pwk-subject/pwkSgjcsjDetail`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwkflUsingPost
     * @summary 排污口分类接口
     * @request POST:/pwk-subject/pwkfl
     */
    pwkflUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListPwkflDto>(`/pwk-subject/pwkfl`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwkgkUsingPost
     * @summary 排污口概况
     * @request POST:/pwk-subject/pwkgk
     */
    pwkgkUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPwkgkRespDto>(`/pwk-subject/pwkgk`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwksgjcUsingPost
     * @summary 排污口手工监测
     * @request POST:/pwk-subject/pwksgjc
     */
    pwksgjcUsingPost: (reqDto: CodeReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListPwkSgjcRespDto>(
        `/pwk-subject/pwksgjc`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwkwtqdPageUsingPost
     * @summary 排污口问题清单
     * @request POST:/pwk-subject/pwkwtqdPage
     */
    pwkwtqdPageUsingPost: (reqDto: PwkwtqdPageReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListEventListDto>(
        `/pwk-subject/pwkwtqdPage`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwkxcjlPageUsingPost
     * @summary 排污口巡查记录
     * @request POST:/pwk-subject/pwkxcjlPage
     */
    pwkxcjlPageUsingPost: (reqDto: PwkxcjlPageReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListXcjlPageDto>(
        `/pwk-subject/pwkxcjlPage`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwkzdjcUsingPost
     * @summary 排污口自动监测
     * @request POST:/pwk-subject/pwkzdjc
     */
    pwkzdjcUsingPost: (reqDto: PwkZdjcReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPwkZdjcRespDto>(`/pwk-subject/pwkzdjc`, 'POST', reqDto, cancelToken),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name VideoListUsingPost
     * @summary 视频清单
     * @request POST:/pwk-subject/videoList
     */
    videoListUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListMonitorVideoItemDto>(
        `/pwk-subject/videoList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name ZrztgkUsingPost
     * @summary 责任主体概况
     * @request POST:/pwk-subject/zrztgk
     */
    zrztgkUsingPost: (reqDto: ZrztgkReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListZrztgkRespDto>(`/pwk-subject/zrztgk`, 'POST', reqDto, cancelToken),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name ZxjcUsingPost
     * @summary 在线监测
     * @request POST:/pwk-subject/zxjc
     */
    zxjcUsingPost: (reqDto: PwkZxjcReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPwkZxjcRespDto>(`/pwk-subject/zxjc`, 'POST', reqDto, cancelToken),
  }
  screen = {
    /**
     * No description
     *
     * @tags 智慧河长大屏-首页
     * @name AutoSiteLastWaterLevelUsingGet
     * @summary 站点当前水质获取
     * @request GET:/screen/home/autoSiteLastWaterLevel
     */
    autoSiteLastWaterLevelUsingGet: (
      query?: { ly?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListStationListForMapModel>(
        `/screen/home/autoSiteLastWaterLevel${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-首页
     * @name GetHzgzDropBoxUsingGet
     * @summary 河长工作下拉框
     * @request GET:/screen/home/getHzgzDropBox
     */
    getHzgzDropBoxUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(
        `/screen/home/getHzgzDropBox`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-首页
     * @name GetProblemsUsingGet
     * @summary 河长调度-年度问题统计 | 巡河问题
     * @request GET:/screen/home/getProblems
     */
    getProblemsUsingGet: (
      query?: { date?: string; ly?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultProblemDto>(
        `/screen/home/getProblems${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-首页
     * @name GetRiverCountStatisticsInfoUsingGet
     * @summary 河库概况-河流统计
     * @request GET:/screen/home/getRiverCountStatisticsInfo
     */
    getRiverCountStatisticsInfoUsingGet: (
      query?: { ly?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListRiverCountDto>(
        `/screen/home/getRiverCountStatisticsInfo${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-首页
     * @name GetRiverLeaderQuantityUsingGet
     * @summary 河长工作-人数统计 | 河长体系
     * @request GET:/screen/home/getRiverLeaderQuantity
     */
    getRiverLeaderQuantityUsingGet: (
      query?: { ly?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultRiverLeaderQuantityDto>(
        `/screen/home/getRiverLeaderQuantity${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-首页
     * @name MapAreaSelectUsingGet
     * @summary 首页河流区域下拉框
     * @request GET:/screen/home/mapAreaSelect
     */
    mapAreaSelectUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListHomeDropSelect>(
        `/screen/home/mapAreaSelect`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-首页
     * @name MapDropListUsingGet
     * @summary 地图下拉导航栏
     * @request GET:/screen/home/mapDropList
     */
    mapDropListUsingGet: (query?: { area?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListHomeMapDropDto>(
        `/screen/home/mapDropList${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-首页
     * @name GetMonitorStatisticsUsingGet
     * @summary 首页监测数统计
     * @request GET:/screen/home/monitorStatistics
     */
    getMonitorStatisticsUsingGet: (
      query?: { type?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultOnlineMonitorStatisticsDto>(
        `/screen/home/monitorStatistics${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-首页
     * @name TotalSkUsingGet
     * @summary 河库概况-水库统计
     * @request GET:/screen/home/totalSk
     */
    totalSkUsingGet: (query?: { ly?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultHkSlDto>(
        `/screen/home/totalSk${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-首页
     * @name WaterAssessmentUsingGet
     * @summary 水环境质量 | 河流水质
     * @request GET:/screen/home/waterAssessment
     */
    waterAssessmentUsingGet: (
      query: { ly?: string; month: string; type?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWaterAssessmentDto>(
        `/screen/home/waterAssessment${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-首页
     * @name WaterAssessmentDropBoxUsingGet
     * @summary 水环境质量下拉框
     * @request GET:/screen/home/waterAssessmentDropBox
     */
    waterAssessmentDropBoxUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(
        `/screen/home/waterAssessmentDropBox`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-首页
     * @name WaterPollutionStatisticsUsingGet
     * @summary 水域污染源-统计数据
     * @request GET:/screen/home/waterPollutionStatistics
     */
    waterPollutionStatisticsUsingGet: (
      query?: { ly?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWaterPollutionDto>(
        `/screen/home/waterPollutionStatistics${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-首页
     * @name WgyWtInfoUsingGet
     * @summary 河长调度-问题详情(含处理流程)
     * @request GET:/screen/home/wgyWtInfo
     */
    wgyWtInfoUsingGet: (query: { id: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultEventDetailDto>(
        `/screen/home/wgyWtInfo${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 市局大屏接口（永川区流域数据监控系统）
     * @name GetPwkInfoUsingGet1
     * @summary 河长数量统计
     * @request GET:/screen/shijudaping/getHzQuantityStatistics
     */
    getPwkInfoUsingGet1: (
      query?: { ly?: string; zj?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultMapStringObject>(
        `/screen/shijudaping/getHzQuantityStatistics${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 市局大屏接口（永川区流域数据监控系统）
     * @name GetPwkInfoUsingGet
     * @summary 获取排污口信息
     * @request GET:/screen/shijudaping/getPwkInfo
     */
    getPwkInfoUsingGet: (query: { pwkCode: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultSjfxPwkxxInfoDto>(
        `/screen/shijudaping/getPwkInfo${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 市局大屏接口（永川区流域数据监控系统）
     * @name GetRankingLatestTimeUsingGet
     * @summary 镇街考核-获取考核排名最新时间
     * @request GET:/screen/shijudaping/getRankingLatestTime
     */
    getRankingLatestTimeUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultRankingTimesDto>(
        `/screen/shijudaping/getRankingLatestTime`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 市局大屏接口（永川区流域数据监控系统）
     * @name GetRankingsDetailUsingGet
     * @summary 镇街考核-获取考核信息详情
     * @request GET:/screen/shijudaping/getRankingsDetail
     */
    getRankingsDetailUsingGet: (
      query: { ly?: string; month: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListAssessmentRankingsDto>(
        `/screen/shijudaping/getRankingsDetail${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 市局大屏接口（永川区流域数据监控系统）
     * @name MapfilterUsingGet
     * @summary 地图点位筛选
     * @request GET:/screen/shijudaping/mapfilter
     */
    mapfilterUsingGet: (
      query: {
        keyword?: string
        ly?: string
        positions: string
        timeUnit?: string
        zjName?: string
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultMapFilterDto>(
        `/screen/shijudaping/mapfilter${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * @description 在线网格员
     *
     * @tags 市局大屏接口（永川区流域数据监控系统）
     * @name GetOnlineWgyUsingPost
     * @summary 在线网格员
     * @request POST:/screen/shijudaping/onlineWgy
     */
    getOnlineWgyUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListXhIndexDto>(
        `/screen/shijudaping/onlineWgy`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name CkzbUsingPost1
     * @summary 查看周边
     * @request POST:/screen/shijudaping/pwk-subject/ckzb
     */
    ckzbUsingPost1: (reqDto: CodeReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPwkCkzbRespDto>(
        `/screen/shijudaping/pwk-subject/ckzb`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name DefaultVideoUsingPost1
     * @summary 默认视频展示
     * @request POST:/screen/shijudaping/pwk-subject/defaultVideo
     */
    defaultVideoUsingPost1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListVideoStreamDto>(
        `/screen/shijudaping/pwk-subject/defaultVideo`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name MatchPwkAndPrintUsingPost1
     * @summary 匹配排污口和监测点
     * @request POST:/screen/shijudaping/pwk-subject/matchPwkAndPrint
     */
    matchPwkAndPrintUsingPost1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(
        `/screen/shijudaping/pwk-subject/matchPwkAndPrint`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwkBasicUsingPost1
     * @summary 排污口基本信息
     * @request POST:/screen/shijudaping/pwk-subject/pwkBasic
     */
    pwkBasicUsingPost1: (reqDto: CodeReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPwkBasicRespDto>(
        `/screen/shijudaping/pwk-subject/pwkBasic`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwkSgjcsjUsingPost1
     * @summary 排污口手工监测数据-雨水排口
     * @request POST:/screen/shijudaping/pwk-subject/pwkSgjcsj
     */
    pwkSgjcsjUsingPost1: (reqDto: PwkSgjcsjReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListPwkSgjcsjRespDto>(
        `/screen/shijudaping/pwk-subject/pwkSgjcsj`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwkSgjcsjDetailUsingPost1
     * @summary 排污口手工监测数据-雨水排口-详情
     * @request POST:/screen/shijudaping/pwk-subject/pwkSgjcsjDetail
     */
    pwkSgjcsjDetailUsingPost1: (
      reqDto: PwkSgjcsjDetailReqDto,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultPwkSgjcsjDetailRespDto>(
        `/screen/shijudaping/pwk-subject/pwkSgjcsjDetail`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwkflUsingPost1
     * @summary 排污口分类接口
     * @request POST:/screen/shijudaping/pwk-subject/pwkfl
     */
    pwkflUsingPost1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListPwkflDto>(
        `/screen/shijudaping/pwk-subject/pwkfl`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwkgkUsingPost1
     * @summary 排污口概况
     * @request POST:/screen/shijudaping/pwk-subject/pwkgk
     */
    pwkgkUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPwkgkRespDto>(
        `/screen/shijudaping/pwk-subject/pwkgk`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwksgjcUsingPost1
     * @summary 排污口手工监测
     * @request POST:/screen/shijudaping/pwk-subject/pwksgjc
     */
    pwksgjcUsingPost1: (reqDto: CodeReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListPwkSgjcRespDto>(
        `/screen/shijudaping/pwk-subject/pwksgjc`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwkwtqdPageUsingPost1
     * @summary 排污口问题清单
     * @request POST:/screen/shijudaping/pwk-subject/pwkwtqdPage
     */
    pwkwtqdPageUsingPost1: (reqDto: PwkwtqdPageReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListEventListDto>(
        `/screen/shijudaping/pwk-subject/pwkwtqdPage`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwkxcjlPageUsingPost1
     * @summary 排污口巡查记录
     * @request POST:/screen/shijudaping/pwk-subject/pwkxcjlPage
     */
    pwkxcjlPageUsingPost1: (reqDto: PwkxcjlPageReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListXcjlPageDto>(
        `/screen/shijudaping/pwk-subject/pwkxcjlPage`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name PwkzdjcUsingPost1
     * @summary 排污口自动监测
     * @request POST:/screen/shijudaping/pwk-subject/pwkzdjc
     */
    pwkzdjcUsingPost1: (reqDto: PwkZdjcReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPwkZdjcRespDto>(
        `/screen/shijudaping/pwk-subject/pwkzdjc`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name VideoListUsingPost1
     * @summary 视频清单
     * @request POST:/screen/shijudaping/pwk-subject/videoList
     */
    videoListUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListMonitorVideoItemDto>(
        `/screen/shijudaping/pwk-subject/videoList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name ZrztgkUsingPost1
     * @summary 责任主体概况
     * @request POST:/screen/shijudaping/pwk-subject/zrztgk
     */
    zrztgkUsingPost1: (reqDto: ZrztgkReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListZrztgkRespDto>(
        `/screen/shijudaping/pwk-subject/zrztgk`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 排污口专题接口
     * @name monitorLifeInfoPOST
     * @summary 在线监测
     * @request POST:/screen/shijudaping/pwk-subject/monitorLifeInfo
     */
    monitorLifeInfoPOST: (reqDto: PwkZxjcReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPwkZxjcRespDto>(
        `/screen/shijudaping/pwk-subject/monitorLifeInfo`,
        'POST',
        reqDto,
        cancelToken
      ),

      /**
     * No description
     *
     * @tags 排污口专题接口
     * @name monitorDeviceGroupUsingGET
     * @summary 排污口感知设备分组清单
     * @request POST:/screen/shijudaping/pwk-subject/monitorDeviceGroup
     */
    monitorDeviceGroupUsingGET: (query?: { code?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPwkZxjcRespDto>(
        `/screen/shijudaping/pwk-subject/monitorDeviceGroup${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

      /**
     * No description
     *
     * @tags 排污口专题接口
     * @name getMonitorDataListPost
     * @summary 获取监测数据列表
     * @request POST:/screen/shijudaping/pwk-subject/getMonitorDataList
     */
    getMonitorDataListPost: (reqDto:any, cancelToken?: CancelToken | undefined) =>
      this.request(
        `/screen/shijudaping/pwk-subject/getMonitorDataList`,
        'POST',
        reqDto,
        cancelToken
      ),

      /**
     * No description
     *
     * @tags 排污口专题接口
     * @name getVideoStreamGET
     * @summary 根据视频设备编码获取视频直播流
     * @request POST:/screen/shijudaping/pwk-subject/getVideoStream
     */
    getVideoStreamGET: (query?: { videoDeviceCode?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPwkZxjcRespDto>(
        `/screen/shijudaping/pwk-subject/getVideoStream${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

      /**
     * No description
     *
     * @tags 排污口专题接口
     * @name getVideoProblemListPost
     * @summary 查询视频问题分页列表
     * @request POST:/screen/shijudaping/pwk-subject/getVideoProblemList
     */
    getVideoProblemListPost: (reqDto:any, cancelToken?: CancelToken | undefined) =>
      this.request(
        `/screen/shijudaping/pwk-subject/getVideoProblemList`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 市局大屏接口（永川区流域数据监控系统）
     * @name GetSyaxUsingGet
     * @summary 流域岸线--水域岸线
     * @request GET:/screen/shijudaping/syax
     */
    getSyaxUsingGet: (query?: { ly?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSyaxGroupDto>(
        `/screen/shijudaping/syax${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * @description 对各站点的小时数据进行沿程水质展示
     *
     * @tags 市局大屏接口（永川区流域数据监控系统）
     * @name SzzdzYcszUsingGet
     * @summary 水质自动站沿程水质
     * @request GET:/screen/shijudaping/szzdzYcsz
     */
    szzdzYcszUsingGet: (
      query: { factorCode: string; ly?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultSzzdzYcszRespDto>(
        `/screen/shijudaping/szzdzYcsz${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 市局大屏接口（永川区流域数据监控系统）
     * @name SzzdzYcszFactorUsingGet
     * @summary 水质自动站因子沿程水质***因子
     * @request GET:/screen/shijudaping/szzdzYcszFactor
     */
    szzdzYcszFactorUsingGet: (query?: { ly?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSzzdzYcszFactorRespDto>(
        `/screen/shijudaping/szzdzYcszFactor${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 市局大屏接口（永川区流域数据监控系统）
     * @name GetWrsyBoomListUsingPost
     * @summary 污染溯源--水质异常报警清单
     * @request POST:/screen/shijudaping/wrsySzBoomList
     */
    getWrsyBoomListUsingPost: (
      wrsyProblemQuery: WrsyProblemQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWrsyBoomListStatisticsVO>(
        `/screen/shijudaping/wrsySzBoomList`,
        'POST',
        wrsyProblemQuery,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 市局大屏接口（永川区流域数据监控系统）
     * @name GetWrsySzBoomListUsingPost
     * @summary 污染溯源--污染源异常报警清单
     * @request POST:/screen/shijudaping/wrsyWryBoomList
     */
    getWrsySzBoomListUsingPost: (
      wrsyProblemQuery: WrsyProblemQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWrsyBoomListStatisticsVO>(
        `/screen/shijudaping/wrsyWryBoomList`,
        'POST',
        wrsyProblemQuery,
        cancelToken
      ),

    /**
     * @description 污染源实时排放，污水处理厂排口最新监测数据，用当天的数据补全
     *
     * @tags 市局大屏接口（永川区流域数据监控系统）
     * @name WrysspfImmobilizationFactorUsingGet
     * @summary 污染源排放实时监测
     * @request GET:/screen/shijudaping/wrysspfImmobilizationFactor
     */
    wrysspfImmobilizationFactorUsingGet: (
      query?: { ly?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWrysspfImmobilizationFactorRespDto>(
        `/screen/shijudaping/wrysspfImmobilizationFactor${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 市局大屏接口（永川区流域数据监控系统）
     * @name WrywtListUsingPost
     * @summary 污染源问题列表
     * @request POST:/screen/shijudaping/wrywtList
     */
    wrywtListUsingPost: (reqDto: WrywtListReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultWrywtListRespDto>(
        `/screen/shijudaping/wrywtList`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 市局大屏接口（永川区流域数据监控系统）
     * @name WrywtStatisticalCurveUsingPost
     * @summary 污染源问题统计曲线
     * @request POST:/screen/shijudaping/wrywtStatisticalCurve
     */
    wrywtStatisticalCurveUsingPost: (
      reqDto: WrywtStatisticalCurveReqDto,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWrywtStatisticalCurveRespDto>(
        `/screen/shijudaping/wrywtStatisticalCurve`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 政策法规接口
     * @name LxUsingPost
     * @summary 法规类型
     * @request POST:/screen/shijudaping/zcfg/lx
     */
    lxUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListKeyValue>(
        `/screen/shijudaping/zcfg/lx`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 政策法规接口
     * @name GetInfoUsingPost
     * @summary 政策法规详情
     * @request POST:/screen/shijudaping/zcfg/zcfgInfo
     */
    getInfoUsingPost: (query: IdIntegerQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultSjfxZcfgInfoDto>(
        `/screen/shijudaping/zcfg/zcfgInfo`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 政策法规接口
     * @name ZcfgListUsingPost
     * @summary 政策法规列表
     * @request POST:/screen/shijudaping/zcfg/zcfgList
     */
    zcfgListUsingPost: (reqDto: ZcfgListReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListZcfgListRespDto>(
        `/screen/shijudaping/zcfg/zcfgList`,
        'POST',
        reqDto,
        cancelToken
      ),
  }
}
